import React from 'react'
import PropTypes from 'prop-types'

function FormText({ children, className = '' }) {
  return (
    <>
      <p className={`text-xxs xl:text-xs text-danger mb-0 mt-0.5 md:mt-1 block font-medium ${className}`}>
        {children}
      </p>
    </>
  )
}

FormText.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
}
export default FormText
